module.exports = __webpack_public_path__ + "img/tv.a595f49d.svg";